import { useDispatch } from 'react-redux';

import { useEffect, useState } from 'react';

import { resetProfile } from '../../store/profileSlice';
import { User } from '../../types/User';
import { sanitizeUserSchools } from '../../utils/sanitizeUserSchools';
import { cosmosApi } from '../cosmosAPi/index';

export const useProfileData = (enabled: boolean) => {
  const [userData, setUserData] = useState<User | null>(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!enabled) return;

    const fetchProfileData = async () => {
      const token = localStorage.getItem('token');
      if (!token) return;

      try {
        const response = await cosmosApi().get<User>('/v1/logged-user');
        setUserData(sanitizeUserSchools(response.data));
      } catch {
        dispatch(resetProfile());
      }
    };

    fetchProfileData();
  }, [enabled]);

  return { userData };
};
